<template>
  <div class="progress">
    <div
      :class="{
        'progress-current': isShow,
        'progress-above': overfulfil
      }"
      :style="{
        width: pct,
      }"
    />
  </div>
</template>

<script>
export default {
  props: {
    // 进度百分比
    percent: {
      type: Number,
      default: 0,
    },

    // 是否超额完成
    overfulfil: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    pct() {
      return this.overfulfil ? '100%' : `${this.percent}%`;
    },

    // 是否显示当前进度
    isShow() {
      return this.percent > 0;
    },
  },
};
</script>

<style lang="less" scoped>
.progress {
  width: 100%;
  height: 8px;
  background: #e7eff7;
  border-radius: 8px;
  overflow: hidden;

  &-current {
    height: 100%;
    background: rgba(47, 158, 255, 1);
    border-radius: 8px;
  }

  &-above {
    background: linear-gradient(
      90deg,
      rgba(47, 158, 255, 1) 0%,
      rgba(47, 158, 255, 1) 84%,
      rgba(203, 28, 217, 1) 100%
    );
  }
}
</style>